import { ListSubheader } from '@mui/material';
import { Button } from '@trackman/web-shared-components';
import { ReactComponent as ClearIcon } from 'components/icons/clear.svg';
import { ReactComponent as SwitchIcon } from 'components/icons/switch.svg';
import React from 'react';
import styled, { css } from 'styled-components';
import { brand, darkgrey, divider, white } from 'styles/Colors';

export const Wrapper = styled.div`
  width: 100%;
  background-color: ${white};
`;

export const SessionSettingsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 40px;
  width: fit-content;
  margin: 0 auto;
`;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 80px);
`;

export const EditInputsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-bottom: 16px;
`;

export const TeamSelectContainer = styled.div`
  display: flex;
  gap: 8px;

  label {
    margin-bottom: 0;
  }
`;

export const TeamSelectorWrapper = styled.div<{ disabled?: boolean }>`
  position: relative;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
`;

export const StyledClearIcon = styled((props) => <ClearIcon {...props} />)`
  z-index: 10;
  cursor: pointer;
  position: absolute;
  right: 13px;
  top: 30%;
`;

export const SmallTitle = styled.h3<{ margin: string }>`
  font-family: Lato;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  margin: ${(props) => props.margin};
`;

export const StyledSwitchIcon = styled((props) => <SwitchIcon {...props} />)`
  width: 32px;
  height: 32px;
  padding: 8px;
  margin-top: 15px;
  background: ${divider};
  cursor: pointer;
  opacity: 1;

  ${(props) =>
    props.disabled &&
    css`
      cursor: default;
      opacity: 0.5;
    `}
`;

export const TeamsContainer = styled.div`
  .MuiInputLabel-root.Mui-focused {
    color: ${brand};
  }
`;

export const EditWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  padding: 24px 40px;
`;

export const StyledListSubheader = styled((props) => <ListSubheader {...props} />)`
  &&& {
    color: ${darkgrey};
    font-feature-settings: 'liga' off;
    font-family: Lato;
    font-size: 11px;
    font-style: normal;
    font-weight: 700;
    line-height: 15.4px;
    padding: 8px;
    background-color: ${white};
    position: absolute;
    top: 0;
    width: calc(100% - 16px);
  }
`;

export const EditTeams = styled.div`
  color: var(--Grayscale-textElementGrey, #414141);
  font-family: Lato;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18.2px;
  border: 1px solid #a0a0a0;
  border-radius: 8px;
  padding: 12px;
  margin: 10px 0;
`;

export const TeamsDivider = styled.span`
  display: block;
  width: 1px;
  height: 22px;
  background-color: #e0e0e0;
  margin: 0 12px;
`;

export const TeamWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
`;

export const StyledButton = styled((props) => <Button {...props} />)`
  &&& {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 32px;
    padding: 0;
    background-color: #f5f5f5;
    span {
      margin-right: 0;
      margin-left: 0;
    }
  }
`;

export const ButtonWrapper = styled.div`
  color: var(--grayscale-text-element, #414141);
  font-family: Lato;
  font-size: 22px;
  font-weight: 700;
  line-height: 30.8px;
  display: flex;
  gap: 12px;
`;
